module.exports = __webpack_public_path__ + "static/img/membership_rights.e756a6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/membership_rights.png
// module id = R8AL
// module chunks = 1